import { render } from "./TopUpModal.vue?vue&type=template&id=d8347ece&scoped=true"
import script from "./TopUpModal.vue?vue&type=script&lang=js"
export * from "./TopUpModal.vue?vue&type=script&lang=js"

import "./TopUpModal.vue?vue&type=style&index=0&id=d8347ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8347ece"]])

export default __exports__